const EntityTypeCodes = {
  Individual: 'Individual',
  Company: 'Company',
  Trust: 'Trust',
  Organisation: 'Organisation',
}; 
export default EntityTypeCodes;